import React, { useEffect, useMemo, useState } from 'react';

import { useLocation } from 'react-router-dom';

import useAppNavigation from '~/hooks/useAppNavigation';

import TagCreate from './TagCreate';
import TagEdit from './TagEdit';
import TagsList from './TagsList';

export default function Tags() {
  const { push } = useAppNavigation();
  const location = useLocation();
  const [view, setView] = useState<'list' | 'create' | 'edit'>('list');
  const [selectedTagId, setSelectedTagId] = useState<string | null>(null);
  const requestedTagId = useMemo(
    () => new URLSearchParams(location.search).get('tagId')?.trim() || null,
    [location.search],
  );

  useEffect(() => {
    if (requestedTagId) {
      setSelectedTagId(requestedTagId);
      setView('edit');
    }
  }, [requestedTagId]);

  const handleBack = () => {
    setView('list');
    setSelectedTagId(null);

    if (requestedTagId) {
      push('/marketing/tags');
    }
  };

  const handleCreate = () => {
    setView('create');
    setSelectedTagId(null);
  };

  const handleEdit = (tagId: string) => {
    setView('edit');
    setSelectedTagId(tagId);
  };

  const handleViewContent = (tagName: string) => {
    push(`/marketing/content?query=${encodeURIComponent(tagName)}`);
  };

  return (
    <>
      {view === 'create' && <TagCreate onBack={handleBack} />}
      {view === 'edit' && selectedTagId && (
        <TagEdit tagId={selectedTagId} onBack={handleBack} onViewContent={handleViewContent} />
      )}
      {view === 'list' && <TagsList onCreate={handleCreate} onEdit={handleEdit} onViewContent={handleViewContent} />}
    </>
  );
}
